export default __webpack_public_path__ + "static/media/washupBirthdayPromotionBanner.11e8b4f4.png";